import { constants, rem, Styles, theme } from '@/styles';

export const styles: Styles = {
  display: 'block',
  position: 'relative',
  paddingLeft: 28,
  cursor: 'pointer',
  fontSize: rem(constants.fontSize.medium),
  userSelect: 'none',
  paddingTop: constants.offset.xsmall,
  color: theme.textPrimary,

  '&:not(:first-of-type)': {
    marginTop: constants.offset.xsmall,
  },

  input: {
    position: 'absolute',
    opacity: 0,
    height: 0,
    width: 0,
  },

  '.checkmark': {
    position: 'absolute',
    top: 6,
    left: 0,
    height: 16,
    width: 16,
    backgroundColor: theme.backgroundPrimary,
    borderRadius: '50%',
    border: `1px solid ${theme.borderSecondary}`,
    transition: 'background-color .15s ease-in',

    '&:after': {
      content: '""',
      position: 'absolute',
      opacity: 0,
    },
  },

  'input ~ .checkmark:after': {
    opacity: 1,
  },

  '&.unchecked': {
    'input ~ .checkmark': {
      border: `1px solid ${theme.borderSecondary}`,
    },
  },

  '&.checked': {
    'input ~ .checkmark': {
      border: `1px solid ${theme.primary}`,
      backgroundColor: theme.backgroundPrimary,
    },

    '.checkmark:after': {
      left: 3,
      top: 3,
      width: 10,
      height: 10,
      borderRadius: '50%',
      backgroundColor: theme.primary,
    },
  },

  '&.disabled': {
    cursor: 'not-allowed',
    color: theme.textDisabled,

    'input ~ .checkmark': {
      border: `1px solid ${theme.backgroundSecondaryDisabled}`,
      backgroundColor: theme.backgroundPrimary,

      '&:after': {
        backgroundColor: theme.backgroundSecondaryDisabled,
      },
    },
  },
};
